<cyborg-select
  class="dropdown"
  (selectChanged)="onSelect($event)"
  [options]="options"
  [selected]="sort$ | async"
></cyborg-select>
